import React from 'react'
import circle from '../images/circle.svg'
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const Experience = ({ tgl, company, role, task1, task2, task3 }) => {

    const { ref, inView } = useInView();

    const animation = useAnimation();
    const animation2 = useAnimation();


    useEffect(() => {
        if (inView) {
            animation.start({
                x: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });

            animation2.start({
                x: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.6,
                }
            });
        }
        if (!inView) {
            animation.start({
                x: -30,
                opacity: 0,
            });

            animation2.start({
                x: -30,
                opacity: 0,
            });
        }
    }, [inView]);

    return (
        <div ref={ref} className='lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 mb-[4em]'>
            <motion.p
                animate={animation}
                className='opacity-[60%] text-4 mb-2 lg:mb-0'>{tgl}</motion.p>
            <motion.div
                animate={animation2}
                className='lg:col-start-2 lg:col-end-5 lg:ml-8'>
                <h3 className='text-[1.3em] items-center font-[700]'>{company}</h3>
                <p className='text-yellow text-[1.2em] font-[600]'>{role}</p>
                <ul className='mt-6 space-y-[1.06em]'>
                    <li className='flex gap-4 items-baseline'><img src={circle} alt="circle" className='w-[.8em]' />{task1}</li>
                    <li className='flex gap-4 items-baseline'><img src={circle} alt="circle" className='w-[.8em]' />{task2}</li>
                    <li className='flex gap-4 items-baseline'><img src={circle} alt="circle" className='w-[.8em]' />{task3}</li>

                </ul>
            </motion.div>
        </div>
    )
}

export default Experience
